import { animated, useSpring } from '@react-spring/web';
import type { PropsWithChildren, ReactNode } from 'react';
import { Children } from 'react';
import styled from 'styled-components';

import { Horizontal } from '#src/atoms/layout/flex/index.tsx';

const Wrapper = styled(Horizontal).attrs({ gap: 0, center: true })`
  display: grid;
`;
const ElementInFan = styled(animated.div)`
  grid-area: 1 / 1;
  transform-origin: center bottom;
  > * {
    filter: drop-shadow(0 var(--unit) var(--unit) rgba(0, 0, 0, 0.5));
  }
`;

export const Fan = ({ children }: PropsWithChildren): ReactNode => {
  const nbElements = Children.count(children);
  const spring = useSpring({
    from: { fanOut: 0 },
    to: { fanOut: 1 },
    delay: 500,
  });

  if (nbElements === 0) {
    return null;
  }
  if (nbElements === 1) {
    return children;
  }

  const fanAngle = Math.min((nbElements - 1) * 15, 45);
  const cardFanAngle = nbElements === 1 ? 0 : fanAngle / (nbElements - 1);
  const tilt = Math.min(-5, fanAngle / -2);

  return (
    <Wrapper>
      {Children.map(children, (child, index) => {
        return (
          <ElementInFan
            // oxlint-disable-next-line react/no-array-index-key
            key={index}
            style={{
              transform: spring.fanOut.to(
                fanOut =>
                  `rotate(${
                    fanOut * cardFanAngle * (nbElements - index - 1) +
                    tilt * fanOut
                  }deg)`
              ),
            }}
          >
            {child}
          </ElementInFan>
        );
      })}
    </Wrapper>
  );
};
